import React from 'react';
import Title from '../../Title';
import Menu from '../../../components/Menu';
import { useHistory } from 'react-router-dom';
import {
    doubleColumnGrid,
    gridColumnsSpacing,
    gridRowsSpacing,
    singleColumnGrid,
    tabsData,
    URL_MAIN_INFO,
    URL_TAB_PARAM,
} from '../../../../../utils/property/propertyUtils';
import Card from '../../../../../muiComponents/Card';
import StarRating from './StarRating';
import {
    usePropertyFetching,
    usePropertyPresentation,
} from '../../../../contextsProperty/ContextProperties';
import Grid from '../../../../../muiComponents/Grid';
import GridChild from '../../../../../muiComponents/GridChild';
import LoadingPlaceholder from '../../../../../muiComponents/LoadingPlaceholder';
import LabelAndContentBlock from '../../LabelAndContentBlock';
import useUserProfile from '../../../../../customHooks/useUserProfile';

const MainInfoSection = () => {
    const history = useHistory();
    const path = history.location.pathname;

    const { name, hotelCategory, rating, address, email, phone } =
        usePropertyPresentation();
    const { isFetching } = usePropertyFetching();
    const { readOnlyUser } = useUserProfile();

    return (
        <section className='flex-column gap-5'>
            {isFetching ? (
                <LoadingPlaceholder variant='text' height={40} />
            ) : (
                <div className='flex flex-between  flex-align-center'>
                    <Title text='main_info' />
                    {readOnlyUser ? (
                        ''
                    ) : (
                        <Menu
                            menuItems={[
                                {
                                    text: 'edit',
                                    icon: 'Edit',
                                    onClick: () => {
                                        const tab =
                                            tabsData.main_info.tabs[0]
                                                .tabNumber;

                                        history.push(
                                            `${path}${URL_MAIN_INFO}${URL_TAB_PARAM(
                                                tab
                                            )}`
                                        );
                                    },
                                },
                            ]}
                        />
                    )}
                </div>
            )}

            <Card className='padding20 flex-column gap-20'>
                <div>
                    {isFetching ? (
                        <LoadingPlaceholder variant='text' height={20} />
                    ) : (
                        <>
                            <Title
                                text={name}
                                translated={false}
                                className='text-secondary-color'
                            />
                            <StarRating rating={rating} title={hotelCategory} />
                        </>
                    )}
                </div>
                <Grid
                    columnSpacing={gridColumnsSpacing}
                    rowSpacing={gridRowsSpacing}
                >
                    <GridChild gridProps={doubleColumnGrid}>
                        <LabelAndContentBlock
                            label='address'
                            content={address}
                            loading={isFetching}
                        />
                    </GridChild>
                    <GridChild gridProps={singleColumnGrid}>
                        <LabelAndContentBlock
                            label='email2'
                            content={email}
                            loading={isFetching}
                        />
                    </GridChild>
                    <GridChild gridProps={singleColumnGrid}>
                        <LabelAndContentBlock
                            label='phone'
                            content={phone}
                            loading={isFetching}
                        />
                    </GridChild>
                </Grid>
            </Card>
        </section>
    );
};

export default MainInfoSection;
